rdefine('app/products/properties/cards',['backbone','text!products/prop/cards.html','text!products/prop/cards-item.html','text!products/prop/card-plus.html','text!products/prop/cards-modal.html'],function(Backbone,template,templateItem,templatePlus,CardsModalTemplate) {

    var FactoryOfImageUploads = 0;

    var CardModelImage = Backbone.Ribs.View.extend({
        className:'image-in-list',
        media_id:null,
        rawimage: null,
        image:null,
        ignoreupload:true,
        initialize:function() {
            var image = this.model.get("image","");
            if(image && image.length) {
                this.media_id = image.split("/").reverse()[0].split("_")[0];
                this.image = image;
            }
            this.rawimage = this.model.get("rawimage",null);
            this.makeCropper();
        },
        makeCropper:function() {
            var self=this;
            this.cropper = Slim.create(this.el, {
                meta:{
                    media_id:this.media_id
                },
               // push:true,
                ratio:'100:60',
                "label":LANGUAGE["slim.label"],
                "buttonCancelTitle":LANGUAGE["basic.cancel"],
                "buttonEditTitle":LANGUAGE["slim.button-edit-title"],
                "buttonRemoveTitle":LANGUAGE["slim.button-remove-title"],
                "buttonDownloadTitle":LANGUAGE["slim.button-download-title"],
                "buttonUploadTitle":LANGUAGE["slim.button-upload-title"],
                "buttonConfirmTitle":LANGUAGE["basic.apply"],
                "buttonCancelLabel":LANGUAGE["basic.cancel"],
                "buttonEditLabel":LANGUAGE["slim.button-edit-label"],
                "buttonRemoveLabel":LANGUAGE["slim.button-remove-label"],
                "buttonDownloadLabel":LANGUAGE["slim.button-download-label"],
                "buttonUploadLabel":LANGUAGE["slim.button-upload-label"],
                "buttonConfirmLabel":LANGUAGE["basic.apply"],
                /*   defaultInputName: this.fieldName+'[]',*/
                didInit: function() {
                    // load the file to our slim cropper
                    if(self.rawimage) {
                        this.load(self.rawimage.output ? self.rawimage.output.image : self.rawimage);
                        self.rawimage = null;
                        self.model.set("rawimage",null);

                    }
                    if(self.image) {
                        this.load(self.image, { blockPush:true });
                    }
                    self.$el.closest('form').attr('data-dirty',true);
                },
                didRemove: function() {
                    self.cropper.remove();
                    this.destroy();
                    self.collection.remove(self.model);
                    self.collection.trigger("pack-models");

                    self.$el.closest('form').attr('data-dirty',true);
                },
                willSave: function(data, ready) {
                    console.log('willsave', data);
                    data.meta.media_id = self.media_id;
                    ready(data);
                },
                didSave:function(data) {
                    data.meta.media_id = self.media_id;
                    self.model.set('rawimage',data);
                    self.collection.trigger("pack-models");
                    console.log('didSave', arguments);
                },
                willRequest:function(xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', CSRF);
                    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                },
                didUpload:function(a,req,resp) {
                    if(resp.status) {
                        self.media_id = resp.media_id;
                        self.model.set("image",resp.path);
                        self.model.set("media_id",resp.media_id);
                        self.collection.trigger("pack-models");
                    }

                }//,
                //service:'/products-upload-to-app'
            });
        }
    });

    var ModalCardProp = Backbone.Ribs.View.extend({
        bindings:{
            'textarea':{
                value:{data:'model.text',events:'change keyup summernote.change'}
            },
            '.title-form': { value: { data: 'model.title', events:'change keyup' } },
            '.images-list':{
                collection:{
                    col: 'images',
                    view: CardModelImage
                }
            }
        },
        images:null,
        initialize:function(opts) {
            this.isnew = opts.modalOpts.config.isnew;
            this.model = opts.modalOpts.config.model;
            this.images = new Backbone.Ribs.Collection(this.model.get("images",[]), {model:Backbone.Ribs.Model});
            this.images.on("pack-models", this.packImagesModels.bind(this));

            this.$el.html(Template7.compile(CardsModalTemplate));
            this.$el.find('textarea').val(this.model.get("text"));
            AppendTextAreaWISYWIG(this.$el.find('textarea')[0]);

            ++FactoryOfImageUploads;
            this.$el.find(".drop-zone-file-choices label").attr("for","CARD_MODAL_FACTORY_"+FactoryOfImageUploads);
            this.$el.find(".drop-zone-file-choices input").attr("id","CARD_MODAL_FACTORY_"+FactoryOfImageUploads);
            this.attachImageUploadFactory(this.$el.find(".drop-zone-file-choices input")[0]);
        },
        attachImageUploadFactory:function(el) {
            var content = $(el).parent().find('label')[0];
            content.addEventListener('dragover', this.handleDragOver.bind(this));
            content.addEventListener('dragleave', this.handleDragLeave.bind(this));
            content.addEventListener('drop', this.handleDrop.bind(this));
            el.addEventListener('change', this.handleFileSelect.bind(this));
        },
        handleDragOver: function (e) {
            e.preventDefault();
            if(!this.$el.hasClass("hover-drag"))
                this.$el.addClass("hover-drag");
        },
        handleDragLeave: function (e) {
            e.preventDefault();
            this.$el.removeClass("hover-drag");
        },
        handleDrop:function (e) {
            e.preventDefault();
            this.$el.removeClass("hover-drag");
            this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
        },
        handleFileSelect:function(e) {
            this.handleFileItems(e.target.files);
        },
        handleFileItems:function(items) {
            var l = items.length;
            for (var i=0; i<l; i++) {
                this.handleItem(items[i]);
            }
        },
        handleItem:function(item) {

            // get file from item
            var file = item;
            if (item.getAsFile && item.kind =='file') {
                file = item.getAsFile();
            }

            this.handleFile(file);
            this.$el.find(".drop-zone-file-choices input")[0].value = '';
        },
        handleFile: function(file) {
           // this.createCropper(file);
            this.images.add({rawimage: file});
        },
        packImagesModels:function(){
            var images = [];
            this.images.map(function(image) {
                images.push(image.attributes);
            });
            this.model.set("images",images);
        }
    });

    var CardItemPlus = Backbone.Ribs.View.extend({
        className:'card-item',
        events:{
            "click":"onClick"
        },
        pmodel:null,
        initialize:function(options) {
            this.$el.html(Template7.compile(templatePlus)());
        },
        onClick: function(e) {
            e.preventDefault();
            this.pmodel = new Backbone.Ribs.Model({media:null, title:'', text:''});
            var modal = new ModalWrapper({
                title:window.LANGUAGE['products.property.cards.new.title'],
                buttons:[
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-default',
                        cbs:[],
                        event:'close'
                    },
                    {
                        'id':'add',
                        title:window.LANGUAGE['products.property.cards.modal.buttons.add'],
                        style:'btn-primary',
                        cbs:[this.onAddClick.bind(this)],
                        event:'close'
                    },
                ],
                content:ModalCardProp,
                config:{
                    isnew:true,
                    model: this.pmodel
                }
            });
            modal.show();

            return false;
        },
        onAddClick:function(id) {
            this.collection.controller.addNewModel(this.pmodel);
            return true;
        }
    });

    var CardDot = Backbone.Ribs.View.extend({
        bindings:{
            el:{
                classes:{
                    active:'model.active'
                }
            }
        },
        tagName:'li',
        initialize:function() {

        }
    });

    var CardItem = Backbone.Ribs.View.extend({
        className:'card-item',
        bindings:{
            'h5':{ text:{data:'model.title', processor: function(a) { return a.length ? a : '-';}}  },
            '.card-item-body':{ html: {data:'model.text', processor: function(a) { return a.length ? a : '-';}} },
            'ul.dots':{
                collection:{
                    col:'images',
                    view:CardDot
                }
            }
        },
        events:{
            "click .remove-button":'onRemove',
            'click':'onEdit'
        },
        images:null,
        initialize:function(options) {
            this.$el.html(Template7.compile(templateItem)());
            this.images = new Backbone.Ribs.Collection([],{model:Backbone.Ribs.Model});
            this.images.reset(this.model.get("images",[]));
            this.showFirstImage();
            var i = 0;
           /* setInterval(function(){
                this.dots.at(i).set("active",false);
                i = ++i % this.dots.length;
                this.dots.at(i).set("active",true);
                this.$el.find(".image-next").addClass("active");
                setTimeout(function(){
                    this.$el.find(".image-next").removeClass("active");
                }.bind(this),600);
            }.bind(this),1500);*/
        },
        onRemove:function(e) {
            e.preventDefault();

            var modal = new ModalWrapper({
                title:window.LANGUAGE['products.property.cards.delete-warring.title'],
                buttons:[
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-default',
                        cbs:[],
                        event:'close'
                    },
                    {
                        'id':'delete',
                        title:window.LANGUAGE['basic.delete'],
                        style:'btn-danger',
                        cbs:[
                            this.doRemove.bind(this)
                        ],
                        event:'close'
                    }
                ],
                content:window.LANGUAGE['products.property.cards.modal.delete-warring']
            });
            modal.show();
            return false;
        },
        doRemove:function(id) {
            this.collection.remove(this.model);
            return true;
        },
        onRemoveSecond:function() {
            var modal = new ModalWrapper({
                title:window.LANGUAGE['products.property.cards.delete-warring.title'],
                buttons:[
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-default',
                        cbs:[],
                        event:'close'
                    },
                    {
                        'id':'delete',
                        title:window.LANGUAGE['basic.delete'],
                        style:'btn-danger',
                        cbs:[
                            function(){
                                this.doRemove();
                                this.imodal.hide();
                                return false;
                            }.bind(this)
                        ],
                        event:'close'
                    }
                ],
                content:window.LANGUAGE['products.property.cards.modal.delete-warring']
            });
            modal.show();
        },
        onEdit: function(e) {
            this.pmodel = new Backbone.Ribs.Model(this.model.attributes);
            this.imodal = new ModalWrapper({
                title:window.LANGUAGE['products.property.cards.edit.title'],
                buttons:[
                    {
                        'id':'delete',
                        title:window.LANGUAGE['products.property.cards.modal.buttons.delete'],
                        style:'btn-danger',
                        cbs:[this.onRemoveSecond.bind(this)],
                        event:''
                    },
                    {
                        seperate:true
                    },
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-default',
                        cbs:[],
                        event:'close'
                    },
                    {
                        'id':'save',
                        title:window.LANGUAGE['products.property.cards.modal.buttons.save'],
                        style:'btn-primary',
                        cbs:[this.doSave.bind(this)],
                        event:'close'
                    },
                ],
                content:ModalCardProp,
                config:{
                    isnew:true,
                    model: this.pmodel
                }
            });
            this.imodal.show();
            return false;
        },
        doSave: function(id) {
            this.model.set(this.pmodel.attributes);
            this.collection.controller.setFromItems();
            return true;
        },
        showFirstImage:function() {
            if(this.images.length) {
                if(this.images.models[0].attributes.rawimage) {
                    this.$el.find(".image-self").css("background-image","url('"+this.images.models[0].attributes.rawimage.output.image+"')");
                }else{
                    this.$el.find(".image-self").css("background-image","url('"+this.images.models[0].attributes.image+"')");
                }

                this.images.models[0].set("active",true);
            }

            setTimeout(this.showNextImage.bind(this),5000);
        },
        next:0,
        showNextImage:function() {
            if(this.images.length>0) {
                this.images.models[this.next++].set('active',false);
                this.next = this.next % this.images.length;
                this.images.models[this.next].set('active',true);
                if(this.images.models[this.next].attributes.rawimage) {
                    var nextimg = this.images.models[this.next].attributes.rawimage.output.image;
                    this.$el.find(".image-self .image-next").css("background-image","url('"+nextimg+"')").addClass("active");
                    setTimeout(function(){
                        this.$el.find(".image-self").css("background-image","url('"+nextimg+"')");
                        this.$el.find(".image-self .image-next").removeClass("active");
                    }.bind(this),600);
                }else{
                    var nextimg = this.images.models[this.next].attributes.image;
                    this.$el.find(".image-self .image-next").css("background-image","url('"+nextimg+"')").addClass("active");
                    setTimeout(function(){
                        this.$el.find(".image-self").css("background-image","url('"+nextimg+"')");
                        this.$el.find(".image-self .image-next").removeClass("active");
                    }.bind(this),600);
                }
            }
            setTimeout(this.showNextImage.bind(this),5000);
        }
    });

    return Backbone.Ribs.View.extend({
        className:'use-flex-grow',
        bindings:{
            '.cards-list-property':{
                collection:{
                    col:'items',
                    view:function(opts) {
                        return opts.model.get("plus",false) ? new CardItemPlus(opts) : new CardItem(opts);
                    }
                }
            }
        },
        events:{

        },
        pmodel:null,
        items: null,
        initialize:function(options) {
            this.cform = options.cform;
            this.items = new Backbone.Ribs.Collection([],{model:Backbone.Ribs.Model});
            this.items.controller = this;
            this.field = 'property_'+this.model.get("id");
            this.$el.html(Template7.compile(template)());

            this.cform.on("change:"+this.field,function(){
                this.resetItems();
            }.bind(this));

            this.items.on("add remove", this.setFromItems.bind(this));
            this.resetItems();
        },
        resetItems: function() {
            console.log("reset items", this.cform.get(this.field));
            var base = [];
            var items = [];
            try {
                console.log("current cform", this.cform.get(this.field));
                items = JSON.parse(this.cform.get(this.field));
            } catch(e) {
                items = [];
            }
            for(var key in items) {
                base.push(new Backbone.Ribs.Model(items[key]));
            }

            base.push(new Backbone.Ribs.Model({plus:true}));
            this.items.reset(base);
        },
        setFromItems: function() {
            var set = new Array();

            this.items.map(function(item){
                if (!item.attributes.plus) {
                    set.push(new Backbone.Ribs.Model(item.attributes));
                }
            });

            this.cform.set(this.field, JSON.stringify(set), { slient: true });
            this.cform.trigger('change:' + this.field);
        },
        addNewModel: function(model) {
            console.log('add model', model);
            this.items.add(model, {silent:true});
            this.setFromItems();
            return false;
        }
    });
});